module.exports = __webpack_public_path__ + "static/img/21606375.c10.94b30e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/rowdy-coyote/21606375.c10.jpg
// module id = 2N9I
// module chunks = 2